import moment from 'moment';
import { TranslateResult } from 'vue-i18n';

export class HomeContent {
    public routeCardTitle: TranslateResult;
    public poiCardTitle: TranslateResult;
    public arCardTitle: TranslateResult;
    public favoriteCardTitle: TranslateResult;

    public routeCardImage: TranslateResult;
    public poiCardImage: TranslateResult;
    public arCardImage: TranslateResult;
    public favoriteCardImage: TranslateResult;

    public hasFavorites: boolean = false;
}

export class NewsEntry {
    public id: number;
    public title: TranslateResult;
    public text: TranslateResult;
}

export enum OnBoardingsState {
    FIRST_START = 0,
    SECOND_START = 1,
    THIRD_START = 2,
    FOURTH_START = 3,
    RANDOM_WELCOME_MESSAGE = 4,
    EVERYTHING_IN_THE_APP_WAS_ACHIEVED = 5
}

export class OnBoardingData {
    public state: OnBoardingsState;
    public title: TranslateResult;
    public text: TranslateResult;
    public poi: number;

    public static Create(
        state: OnBoardingsState,
        title: TranslateResult,
        text: TranslateResult,
        poi?: number
    ): OnBoardingData {
        const onBoardingData = new OnBoardingData();
        onBoardingData.state = state;
        onBoardingData.title = title;
        onBoardingData.text = text;
        onBoardingData.poi = poi;

        return onBoardingData;
    }
}

export interface OnBoardingProgress {
    state: OnBoardingsState;
    date: moment.Moment;
    userHasClickedAway: boolean;
}

export let DefaultOnBoardingProgress = {
    state: OnBoardingsState.FIRST_START,
    date: moment(),
    userHasClickedAway: false
} as OnBoardingProgress;
